import React, { useState } from 'react';
import Loader from '../components/Loader';
import '../styles/style_test_loader.css';

/**
 * Page de test pour le loader fleuristerie
 * Démontre les différentes tailles et utilisations possibles
 */
const TestLoader = () => {
  const [buttonLoading, setButtonLoading] = useState(false);
  const [cardLoading, setCardLoading] = useState(false);

  const handleButtonClick = () => {
    setButtonLoading(true);
    setTimeout(() => setButtonLoading(false), 3000);
  };

  const handleCardClick = () => {
    setCardLoading(true);
    setTimeout(() => setCardLoading(false), 3000);
  };

  return (
    <div className="test-loader-page">
      {/* Hero section avec loader principal */}
      <section className="hero-section">
        <h1 className="page-title">Loader Fleuristerie Premium</h1>
        <p className="page-subtitle">Animation élégante et professionnelle</p>
        <Loader size="xlarge" variant="primary" showLabel label="Chargement" showDots={false} showRing={false} />
      </section>

      {/* Section des différentes tailles */}
      <section className="demo-section">
        <h2 className="section-title">Différentes Tailles</h2>
        <div className="size-demo-grid">
          <div className="demo-item">
            <h3>Small (24px)</h3>
            <p>Idéal pour les boutons et icônes</p>
            <Loader size="small" variant="primary" showLabel={false} label="Chargement" showDots={false} showRing={false} />
          </div>
          
          <div className="demo-item">
            <h3>Medium (48px)</h3>
            <p>Usage standard dans les contenus</p>
            <Loader size="medium" variant="primary" showLabel label="Chargement" />
          </div>
          
          <div className="demo-item">
            <h3>Large (80px)</h3>
            <p>Pour les sections importantes</p>
            <Loader size="large" variant="primary" showLabel label="Chargement" />
          </div>
          
          <div className="demo-item">
            <h3>XLarge (120px)</h3>
            <p>Chargement de page principale</p>
            <Loader size="xlarge" variant="primary" showLabel label="Chargement" />
          </div>
        </div>
      </section>

      {/* Section des variantes */}
      <section className="demo-section dark-section">
        <h2 className="section-title">Variante Light (fond sombre)</h2>
        <div className="variant-demo">
          <Loader size="small" variant="light" showLabel label="Chargement" />
          <Loader size="medium" variant="light" showLabel label="Chargement" />
          <Loader size="large" variant="light" showLabel label="Chargement" />
          <Loader size="xlarge" variant="light" showLabel label="Chargement" />
        </div>
      </section>

      {/* Section des cas d'usage */}
      <section className="demo-section">
        <h2 className="section-title">Cas d'Usage</h2>
        
        <div className="usage-demos">
          {/* Dans un bouton */}
          <div className="usage-example">
            <h3>Dans un bouton</h3>
            <button 
              className="demo-button" 
              onClick={handleButtonClick}
              disabled={buttonLoading}
            >
              {buttonLoading ? (
                <>
                  <Loader size="small" variant="light" />
                  Chargement...
                </>
              ) : (
                'Cliquez pour charger'
              )}
            </button>
          </div>

          {/* Dans une carte */}
          <div className="usage-example">
            <h3>Dans une carte</h3>
            <div className="demo-card" onClick={handleCardClick}>
              <h4>Produit Premium</h4>
              {cardLoading ? (
                <div className="card-loader-container">
                  <Loader size="medium" variant="primary" />
                </div>
              ) : (
                <>
                  <p>Bouquet de roses raffiné</p>
                  <p className="price">89,90 €</p>
                  <button className="card-button">Voir les détails</button>
                </>
              )}
            </div>
          </div>

          {/* En overlay */}
          <div className="usage-example">
            <h3>En overlay sur contenu</h3>
            <div className="demo-overlay-container">
              <div className="demo-content">
                <h4>Contenu chargé</h4>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                <p>Sed do eiusmod tempor incididunt ut labore.</p>
              </div>
              <div className="loader-overlay">
                <Loader size="large" variant="primary" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section contrôles avancés */}
      <section className="demo-section">
        <h2 className="section-title">Contrôles Avancés</h2>
        <div className="size-demo-grid">
          <div className="demo-item">
            <h3>Label désactivé</h3>
            <p>Sans texte de chargement</p>
            <Loader size="medium" variant="primary" showLabel={false} />
          </div>
          <div className="demo-item">
            <h3>Points désactivés</h3>
            <p>Label sans "..."</p>
            <Loader size="medium" variant="primary" showLabel label="Chargement" showDots={false} />
          </div>
          <div className="demo-item">
            <h3>Anneau désactivé</h3>
            <p>Fleur sans anneau rotatif</p>
            <Loader size="medium" variant="primary" showLabel label="Chargement" showRing={false} />
          </div>
          <div className="demo-item">
            <h3>Label vide</h3>
            <p>Texte caché si label=""</p>
            <Loader size="medium" variant="primary" label="" />
          </div>
        </div>
      </section>

      {/* Section informations techniques */}
      <section className="demo-section info-section">
        <h2 className="section-title">Caractéristiques Techniques</h2>
        <div className="features-grid">
          <div className="feature-card">
            <h4>🎨 Design Premium</h4>
            <p>Palette de couleurs harmonieuse inspirée des fleurs, avec des nuances subtiles de rose, mauve et or.</p>
          </div>
          <div className="feature-card">
            <h4>📱 Responsive</h4>
            <p>S'adapte automatiquement à toutes les tailles d'écran avec des breakpoints optimisés.</p>
          </div>
          <div className="feature-card">
            <h4>⚡ Performance</h4>
            <p>Animation CSS pure sans JavaScript, utilisant les propriétés GPU-accelerated.</p>
          </div>
          <div className="feature-card">
            <h4>♿ Accessible</h4>
            <p>Respecte les préférences de mouvement réduit (prefers-reduced-motion).</p>
          </div>
          <div className="feature-card">
            <h4>🎯 Flexible</h4>
            <p>4 tailles prédéfinies, 2 variantes de couleur, utilisable partout.</p>
          </div>
          <div className="feature-card">
            <h4>✨ Élégant</h4>
            <p>Animation fluide avec rotation de pétales, pulsation du centre et anneau décoratif.</p>
          </div>
        </div>
      </section>

      {/* Code d'exemple */}
      <section className="demo-section code-section">
        <h2 className="section-title">Exemples d'Utilisation</h2>
        <div className="code-examples">
          <div className="code-block">
            <h4>Loader simple</h4>
            <pre><code>{`<Loader size="medium" variant="primary" />`}</code></pre>
          </div>
          <div className="code-block">
            <h4>Dans un bouton</h4>
            <pre><code>{`<button disabled={loading}>
  {loading ? (
    <>
      <Loader size="small" variant="light" />
      Chargement...
    </>
  ) : 'Valider'}
</button>`}</code></pre>
          </div>
          <div className="code-block">
            <h4>Plein écran</h4>
            <pre><code>{`<div className="loader-fullscreen">
  <Loader size="xlarge" variant="primary" />
</div>`}</code></pre>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TestLoader;
